import React, { createContext, useContext, useTransition } from "react"
// eslint-disable-next-line no-restricted-imports
import { NavigateOptions, useNavigate } from "react-router"

interface NavigationContextValue {
  navigate: (to: string, options?: NavigateOptions) => void
  isPending: boolean
}

const NavigationContext = createContext<NavigationContextValue>({
  navigate: () => {},
  isPending: false,
})

export const NavigationProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const rawNavigate = useNavigate()
  const [isPending, startTransition] = useTransition()

  const navigate = (to: string, options?: NavigateOptions) => {
    startTransition(() => {
      rawNavigate(to, options)
    })
  }

  return (
    <NavigationContext.Provider value={{ navigate, isPending }}>
      {children}
    </NavigationContext.Provider>
  )
}

export const useNavigationContext = () => useContext(NavigationContext)
